import { useEffect, useState } from 'react';

import { Prize, SackMoney } from 'components/icons';
import {useTranslation} from "react-i18next";

import { getCirculations } from '../../requests';
import Card from '../circulation-card';
import './Circulations.css';

const Circulations = ({circulationData}) => {
  const [circulations, setCirculations] = useState([]);

  const {t} = useTranslation();

  useEffect(() => {
    getCirculations()
      .then((res) => {
        setCirculations(res.data?.data ?? []);
      })
      .catch(() => null);

    const interval = setInterval(() => {
      getCirculations()
        .then((res) => {
          setCirculations(res.data?.data ?? []);
        })
        .catch(() => null);
    }, 600000);

    return () => clearInterval(interval);
  }, []);


  return (
    <div className="home-circulations">
      <div className="container">
        <p className="home-circulations__title">{t("CIRCULATIONS")}</p>
        <div className="home-circulations__container">
          {circulations.map((circulation) => (
            <Card key={circulation.id} data={circulation} response={circulationData} />
          ))}
        </div>
        <div className="container home-circulations__details">
          <div className="home-circulations__detail">
            <SackMoney />
            <p>₼ {circulationData?.maxWinAmount}</p>
            <span>{t("MAX_WINNING_AMOUNT")}</span>
          </div>
          <div className="home-circulations__detail">
            <Prize />
            <p>₼ {circulationData?.jackpotAmount}</p>
            <span>{t("JACKPOT_AMOUNT")}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Circulations;
